import contactpersonApi from "@/api/contactpersonApi";

export default {
  namespaced: true,

  state: {
    coursesLoading: true,
    courses: [],
    coursesContactPerson: [],
  },
  getters: {
    coursesLoading: (state) => {
      return state.coursesLoading;
    },
    courses: (state) => {
      return state.courses;
    },
    coursesContactPerson: (state) => {
      return state.coursesContactPerson;
    },
    coursesToSelect: (state) => {
      const data = state.courses.filter((x) => {
        return !state.coursesContactPerson.find((y) => y.courseId === x.id);
      });
      return data;
    },
    haveAlleCourese: (state, getters) => {
      return getters.coursesToSelect.length === 0;
    },
  },
  mutations: {
    setCourses(state, data) {
      state.courses = data.courses;
      state.coursesContactPerson = data.coursesContactPerson;
      state.coursesLoading = data.coursesLoading;
    },
    updateCoursesContactPerson(state, data) {
      state.coursesContactPerson = data;
    },
  },
  actions: {
    setCourses(context) {
      contactpersonApi.getContactpersonCourses().then((response) => {
        const data = {
          coursesContactPerson: response.coursesContactPerson,
          courses: response.courses,
          coursesLoading: false,
        };

        context.commit("setCourses", data);
      });
    },

    addCourse(context, data) {
      return new Promise((resolve) => {
        const courses = data
          .filter((x) => x.selected)
          .map((x) => {
            return {
              contactPersonId: 557273,
              courseId: x.id,
              expiryDate: x.expiryDate,
              fromDate: null,
              hasExpiryDate: x.hasExpiryDate,
              id: 0,
              name: x.name,
            };
          });

        contactpersonApi.addContactPersonCourses(courses).then((response) => {
          context.commit(
            "updateCoursesContactPerson",
            response.contactPersonCourses
          );
          contactpersonApi.putUserSetting("cometanceUpdated", new Date());
          resolve(true);
        });
      });
    },

    delCourse(context, data) {
      return new Promise((resolve) => {
        contactpersonApi
          .deleteContactPersonCourses(data.id)
          .then((response) => {
            context.commit(
              "updateCoursesContactPerson",
              response.contactPersonCourses
            );
            contactpersonApi.putUserSetting("cometanceUpdated", new Date());
            resolve(true);
          });
      });
    },
    updateCourse(context, data) {
      return new Promise((resolve) => {
        contactpersonApi.updateContactPersonCourses(data).then((response) => {
          context.commit(
            "updateCoursesContactPerson",
            response.contactPersonCourses
          );

          contactpersonApi.putUserSetting("cometanceUpdated", new Date());
          resolve(true);
        });
      });
    },
  },
};
